import React from 'react';
import PlannerSeason from './PlannerSeason';
import PlannerWeek from './PlannerWeek';
import { PLANNER_CSS, isoWeekOf, localToday, parseWeekParam, weekParam } from './plannerShared';
import { useUrlParam } from '../../hooks/useUrlParam';

// Club Planner (staging only) — replaces the trainer's hand-made weekly PDF. Season view (fixtures
// from the feed, +/− day labels, the long-term training / off plan) and week view (the time grid
// of blocks). Access is checked server-side on every planner endpoint (services/planner/routes.js);
// the nav entry only decides whether the tab shows. View and week live in the URL
// (?page=planner&view=week&week=2026-W42) so a week can be linked to.
export default function Planner({ user }) {
  const [view, setView] = useUrlParam('view', 'season');
  const current = isoWeekOf(localToday());
  const [weekStr, setWeekStr] = useUrlParam('week', weekParam(current.isoYear, current.isoWeek));
  const week = parseWeekParam(weekStr) || current;
  const token = user?.sessionToken;

  const openWeek = (isoYear, isoWeek) => {
    setWeekStr(weekParam(isoYear, isoWeek));
    setView('week');
  };

  return (
    <div className="planner-root" style={{ maxWidth: 1500, margin: '0 auto', paddingBottom: 40 }}>
      <style>{PLANNER_CSS}</style>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 14 }}>
        <div>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: 'var(--text-primary)', margin: 0 }}>Club Planner</h2>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
            {view === 'week'
              ? 'Week schedule: who is where, when. Staff see everything; players will only see what concerns them.'
              : 'Season plan: game, training and off days. Fixtures come in from the online fixture feed.'}
          </div>
        </div>
        <div role="group" aria-label="View" style={{ display: 'flex', gap: 4 }}>
          <button className={`pl-btn ${view !== 'week' ? 'pl-btn--active' : ''}`} aria-pressed={view !== 'week'} onClick={() => setView('season')}>Season</button>
          <button className={`pl-btn ${view === 'week' ? 'pl-btn--active' : ''}`} aria-pressed={view === 'week'} onClick={() => setView('week')}>Week</button>
        </div>
      </div>
      {view === 'week'
        ? <PlannerWeek token={token} isoYear={week.isoYear} isoWeek={week.isoWeek} onChangeWeek={openWeek} />
        : <PlannerSeason token={token} onOpenWeek={openWeek} />}
    </div>
  );
}
